import React, { useEffect, useState } from 'react'
import { BreadCrumb } from '../component/BreadCrumb';
import { Button, Card, CardBody, Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import userimg from '../../../../src/assets/images/users/user-dummy-img.jpg'
import { formatDateTime } from '../../../Components/Common/FormatDate';
import classNames from 'classnames';
import classnames from 'classnames';

import { RestroUsers } from '../../../services/DatabaseService/RestroUsers';
import LogsDetails from './Component/LogsDetails';
import PaymentLogs from './Component/Paymentlogs';
import GracePeriodLogs from './Component/GracePeriod';
// import ContactPersonLogs from './Component/ContactPerson';
import ContactPersonForm from '../RestroUsersInfo/component/ContactPersonForm';
import ContactPersonLogs from './Component/ContactPerson';
import { useParams } from 'react-router-dom';

const RestroUserDetails = () => {
    const { apiKey } = useParams();
    const [loading, setLoading] = useState(false);

    const [userData, setUserData] = useState("")
    useEffect(() => {
        const fetchAllData = async () => {
            //   setLoading(true);
            try {
                const result = await RestroUsers.getByApiKey(apiKey);
                setUserData(result);
                // setDataList(dataResult || []);
            } catch (error) {
                console.error("Error fetching data", error);
            } finally {
                setLoading(false);
            }
        };
        fetchAllData();
    }, [apiKey]);

    const [activeTab, setActiveTab] = useState("1");
    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    const toggleContactModal = () => {
        setContactModalOpen(!contactModalOpen);
    };

    const [contactModalOpen, setContactModalOpen] = useState(false);
    if (!userData) return <div>Loading...</div>;

    console.log(userData?.apiKey)
    return (
        <React.Fragment>
            <Container fluid className='px-0'>
                <div className="page-content">
                    <BreadCrumb title="Restro User Log List" pageTitle="Details" />

                    <Row>
                        <Col lg={12}>
                            <Card className="mt-n4 mx-0">
                                <div className="bg-warning-subtle">
                                    <CardBody className="pb-0 ">
                                        <Row className="mb-3">
                                            <div className="col-md">
                                                <Row className="align-items-center g-3">
                                                    {/* <div className="col-md-auto"> */}
                                                    <div className="avatar-md">
                                                        <div className="avatar-title bg-white rounded-circle">
                                                            <img src={userimg} alt="" className="avatar-xs" />
                                                        </div>
                                                    </div>
                                                    {/* </div> */}
                                                    <div className="col-md">
                                                        <div>
                                                            <h4 className="fw-bold">
                                                                {userData?.tenantName ||
                                                                    "Tenant Name Unavailable"}{" "}
                                                            </h4>
                                                            <div className="hstack gap-3 flex-wrap fs-9 text-muted">
                                                                <div>
                                                                    <i className="ri-building-line align-bottom me-1 text-muted"></i>{" "}
                                                                    {userData?.tenantCode}
                                                                </div>
                                                                <div className="vr"></div>
                                                                <div>
                                                                    Registered Date :{" "}
                                                                    <span className="fw-medium">
                                                                        {formatDateTime(userData?.regsiteredDate)}
                                                                    </span>
                                                                </div>
                                                                <div className="vr"></div>
                                                                <div>
                                                                    Valid Till :{" "}
                                                                    <span className="fw-medium">
                                                                        {formatDateTime(userData?.validTill)}
                                                                    </span>
                                                                </div>
                                                                <div className="vr"></div>
                                                                <div>
                                                                    Address :{" "}
                                                                    <span className="fw-medium">
                                                                        {userData?.address}
                                                                    </span>
                                                                </div>
                                                                <div className="vr"></div>
                                                                <br />
                                                                <div>
                                                                    Status :{" "}
                                                                    <span
                                                                        className={`badge rounded-pill ms-1 ${userData?.isActive
                                                                            ? "bg-success-subtle text-success"
                                                                            : "bg-danger-subtle text-danger"
                                                                            }`}
                                                                    >
                                                                        {userData?.isActive ? "Active" : "Inactive"}
                                                                    </span>
                                                                </div>
                                                                <div className="vr"></div>
                                                                {/* <Link to={`/contactperson`}>
                                <Button color="btn btn-soft-success" className="btn-sm ms-1">
                                  Contact Person
                                </Button>
                              </Link> */}

                                                                {/* <div className="vr"></div>
                                                        <div className="badge  bg-info fs-12">New</div>
                                                        <div className="badge  bg-danger fs-12">High</div> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Row>
                                            </div>
                                            <div className="col-md-auto">
                                                <div className="hstack gap-1 flex-wrap">
                                                    {/* <Link to={`/contactdetails`}> */}
                                                    <Button color="btn btn-success" className="btn-sm ms-1 border-0" onClick={toggleContactModal}>
                                                        Contact Person
                                                    </Button>
                                                    {/* </Link> */}
                                                    {/* <button type="button" className="btn py-0 fs-16 text-body">
                          <i className="ri-share-line"></i>
                        </button>
                        <button type="button" className="btn py-0 fs-16 text-body">
                          <i className="ri-flag-line"></i>
                        </button> */}
                                                </div>
                                            </div>
                                        </Row>

                                        <Nav className="nav-tabs-custom border-bottom-0 " role="tablist">
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: activeTab === '1' }, " fw-semibold mx-3")}
                                                    onClick={() => { toggleTab('1'); }}
                                                    href="#">
                                                    Log Details
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: activeTab === '2' }, " fw-semibold me-3")}
                                                    onClick={() => { toggleTab('2'); }}
                                                    href="#">
                                                    Payment Logs
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: activeTab === '3' }, "fw-semibold me-3")}
                                                    onClick={() => { toggleTab('3'); }}
                                                    href="#">
                                                    Grace Period details
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: activeTab === '4' }, " fw-semibold")}
                                                    onClick={() => { toggleTab('4'); }}
                                                    href="#">
                                                    Contact Person
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                    </CardBody>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <TabContent activeTab={activeTab} className="text-muted">
                                <TabPane tabId="1">

                                    <LogsDetails />
                                </TabPane>
                                <TabPane tabId="2">
                                    <PaymentLogs />
                                </TabPane>
                                <TabPane tabId="3">
                                    <GracePeriodLogs />
                                </TabPane>
                                <TabPane tabId="4">
                                    <ContactPersonLogs />
                                </TabPane>
                            </TabContent>
                        </Col>
                    </Row>
                    <ContactPersonForm
                        apiKey={userData?.apiKey}
                        modalOpen={contactModalOpen}
                        toggleModal={toggleContactModal}
                    />

                </div>
            </Container>
        </React.Fragment>
    )
}

export default RestroUserDetails
